<template>
  <div class="p-0 m-0">
    <room-nav-bar />

    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
import RoomNavBar from '@components/room-nav-bar.vue'

export default {
  components: { RoomNavBar },
}
</script>
